export declare const player: (player: Player, serv: Server) => void;
declare global {
    interface Player {
        /** Updates the player's health and sends the relevant packet. */
        "updateHealth": (health: number) => void;
        /** Updates the player's food and sends the relevant packet. */
        "updateFood": (food: number) => void;
        /** Updates the player's food saturation and sends the relevant packet. */
        "updateFoodSaturation": (foodSaturation: number) => void;
    }
}
